module.exports = __webpack_public_path__ + "static/PowerPants_Pleated_Rider-f60b2bade1269a8af4407c46410a372a.png";